import type { z } from 'zod';

/**
 * Turns any passed in ZodSchema into an optional, nullable schema and sets the default value to nulls
 * @param {z.ZodSchema} schema The schema to make optional, nullable and set the default value to null
 */
export function nullishDefault<TSchema extends z.ZodSchema>(schema: TSchema) {
    return schema.nullish().default(null);
}
